<template>
	<div class="order-result-close">
		<img src="../../../assets/img-v2/ic_order_result_close.png" class="icon" />
		<div>
			<div class="title">已结束</div>
			<div class="desc">司机到达站点未找到乘客，请检查选择的上下车点是否正确</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'orderResultClose'
};
</script>

<style scoped lang="scss">
.order-result-close {
	border-radius: 12px;
	background: radial-gradient( 111% 115% at 29% 9%, #F0F7FF 0%, #BBDBFF 50%, #FFFFFF 100%);
	padding: 20px 14px 30px 14px;
	transform: translateY(10px);
	display: flex;
	align-items: center;
	.icon {
		width: 44px;
		height: 44px;
		min-width: 44px;
		margin-right: 12px;
	}
	.title {
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 18px;
		color: #000000;
		line-height: 25px;
	}
	.desc {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: rgba(0,0,0,0.7);
		line-height: 20px;
		margin-top: 4px;
	}
}
</style>
